
import ApiService from './ApiService'

class OrganisationService {

  addOtherAdmin = async (apiToken, orgId, userId) => {
    var url = `/api/organisation/${orgId}/otheradmin/${userId}`

    var params = {}

    var options = {}
    var result = null

    try {
      result = await ApiService.patch(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  removeOtherAdmin = async (apiToken, orgId, userId) => {
    var url = `/api/organisation/${orgId}/otheradmin/${userId}`

    var params = {}

    var options = {}
    var result = null

    try {
      result = await ApiService.sendDelete(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  getOtherAdmins = async (apiToken, organisationId) => {
    var url = `/api/organisation/${organisationId}/otheradmin`

    var params = {
    }
    var otherAdmins = null

    try {
      otherAdmins = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return otherAdmins
  }

  getOrganisations = async (apiToken) => {
    var url = '/api/organisation'

    var params = {
      fields: 'id,name,appSettings,enabledModules'
    }

    try {
      var organisations = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return organisations
  }

  getOrganisation = async (apiToken, organisationId) => {
    var url = `/api/organisation/${organisationId}`

    var params = {
      fields: 'id,name,logoUrl,hasSites,createdAt,admin,sharedIncidentReports,sharedSmartPlans,numAllowedUsers,wondeSync,safeguardingLeads,enablePILExtras,aiTermsAccepted,cpomsEnabled,cpomsDomain,cpomsSyncEverything',
      limit: 1
    }

    try {
      var organisation = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return organisation
  }

  updateOrganisation = async (apiToken, data) => {
    const organisationId = data.id
    var url = `/api/organisation/${organisationId}`

    // var params = {
    //   fields: 'id,firstName,lastName,email,userName',
    //   limit: 1000
    // }

    var params = {}

    var options = {
      data: data
    }

    try {
      var result = await ApiService.put(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  getUserCount = async (apiToken, params, organisationId) => {
    var url = `/api/organisation/${organisationId}/user`

    params.fields = 'id,type'

    try {
      var users = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }

    var userCounts = {}

    if (users?.page?.total) {
      const systemUsers = users.data.filter(user => {
        return user.type === 'user'
      })
      userCounts.systemUsers = systemUsers

      const students = users.data.filter(user => {
        return user.type === 'student'
      })

      userCounts.students = students
    }
    return userCounts
  }

  getRolesForOrg = async (apiToken, organisationId) => {
    var url = `/api/organisation/${organisationId}/role`

    var params = {
      fields: 'id,title,permissions'
    }

    try {
      var roles = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return roles
  }
}
export default new OrganisationService()
